<ng-template [ngIf]="isComunicandoDataAppuntamentoFase2">
  <app-loading></app-loading>
</ng-template>
<div class="d-flex mt-1 ">
  <form [formGroup]="comunicaDataAppuntamentoFase2Form">
    <div class="grid formgrid p-fluid ">
      <div class="field col-12">
        <label for="dataAppuntamento" >Data concordata</label>
        <p-calendar
            formControlName="dataAppuntamento"
            id="dataAppuntamento"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            placeholder="Indica la data dell'appuntamento"
            [appendTo]="'body'"
          ></p-calendar>
      </div>
    
  </div>
</form>
</div>
  <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
    <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
    styleClass="p-button-warning"></p-button>
   <p-button  icon="pi pi-check" label="Conferma"
    class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isComunicandoDataAppuntamentoFase2 || !comunicaDataAppuntamentoFase2Form.valid"></p-button>
</div>
<p-toast />
<p-confirmDialog /> 